import { render, staticRenderFns } from "./FormPendencyNotify.vue?vue&type=template&id=4ccdcf4a&scoped=true"
import script from "./FormPendencyNotify.vue?vue&type=script&lang=js"
export * from "./FormPendencyNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccdcf4a",
  null
  
)

export default component.exports